module.exports = __webpack_public_path__ + "img/1546972883.14a42654.jpg";